import styles from './header.module.scss'

const Header = () => {
  return (
    <div className={styles.header}>
      <div className={styles.logo}>LEEDOCS</div>
      <div className={styles.nav}>NAV</div>
    </div>
  )
}

export default Header
